import messages_es from '../locale-data/es.json';
import messages_en from '../locale-data/en.json';

const languages = {
    es: messages_es,
    en: messages_en,
};
var language = navigator.language.split(/[-_]/)[0]; // language without region code
let customLanguage = sessionStorage.getItem('iflares_language');
if (customLanguage) {
    language = customLanguage;
}
sessionStorage.setItem('iflares_language', language);
console.log('iflares_language', language);
var words = languages[language];

if (words == null) {
    language = 'en';
    words = languages['en'];
}

export default {
    session: !!sessionStorage.jwt,
    activeStep: 0,
    locales: {
        lang: language,
        messages: words,
        languages: languages,
    },
};



// WEBPACK FOOTER //
// ./src/store/initial.state.js